<template>
  <div id="access-control">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          :externalLoading="loading"
          ref="CRUDTable"
          :remoteCreateItem="remoteCreateItem"
          :remoteUpdateItem="remoteUpdateItem"
          :remoteDeleteItem="remoteDeleteItem"
          :remoteGetItem="remoteGetItem"
          :fetchList="fetchList"
          editWith="1000px"
          :searchKeyWord="searchKeyWord"
          :formConfig="formConfig"
          :inputConfigs="inputConfigs"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
          :showExpand="true"
          :expanded.sync="expanded"
          :singleExpand="singleExpand"
          @update:expanded="handleExpanded"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row>
                <v-col>
                  <div class="mt-5">
                    <v-btn
                      @click="saveRoleMenu(item.id)"
                      depressed
                      class="mr-5"
                      color="primary"
                    >
                      Save
                    </v-btn>
                    <v-btn
                      @click="resetRoleMenu(item.id)"
                      depressed
                      class="mr-5"
                      color="secondary"
                    >
                      Reset
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="access-tree" v-for="(endpointMenuItem, index) in endpointMenuItems">
                  <v-treeview
                    v-model="selection[index]"
                    @update:active="(e)=>{handleActive(e,index)}"
                    :active="activeArr[index]"
                    :items="[endpointMenuItem]"
                    selectable
                    return-object
                    open-all
                    activatable
                  ></v-treeview>
                  <!--
                    :active="(e)=>selection[endpointMenuItem.sectionTitle].push(e)"
                    @input="selectedItems => handleTreeview(selectedItems, item.id)"
                    @update:active="(e)=>handleActive(e,endpointMenuItem.sectionTitle)" -->
                </v-col>
              </v-row>
            </td>
          </template>
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { createItem, deleteItem, fetchList, getItem, updateItem, updateRoleMenu } from '@/api/sysRole'
import { fetchListByEndpoint } from '@/api/sysMenu'

import {  fetchList as userFtchList,  updateItem as userUpdateItem } from '@/api/user'
 



import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref, reactive, nextTick } from 'vue'

export default {
  components: {
    CRUDTable,
    // uInput,
    // UserListAddNew,
  },
  methods: {
    saveRoleMenu(roleID){
      console.log('roleID',roleID)
      let sysRoleMenus = []
      for (let index = 0; index < 10; index++) {
        if(this.selection[index] && this.selection[index].length > 0){
          this.selection[index].forEach(menuItem => {
            sysRoleMenus.push({
              SysMenuID: menuItem.id
            })
          })
        }
      }
      let postData = {
        id: roleID,
        SysRoleMenus: sysRoleMenus
      }
      console.log('postData',postData)
      updateRoleMenu(postData).then((response) =>{
        console.log('updateRoleMenu response', response)
      })
    },
    resetRoleMenu(roleId){
      console.log('roleID',roleID)
    },
    handleExpanded(expandedRows) {
      console.log('expandedRows', expandedRows)
      let returnNode = {}
      let getEndNode = (node, id)=>{
        if(returnNode.id){
          return
        }
        // console.log('getEndNode',node.id)
        if(node.id === id){
          returnNode = Object.assign({},node)
          // console.log('returnNode',returnNode)
          return
        }
        if(node.children && node.children.length > 0) {
          node.children.forEach(child=>{
            if(returnNode.id){
              return
            }
            // console.log('child returnNode',returnNode)
            getEndNode(child, id)
          })
        }

      }
      let sysMenuItem = expandedRows[0].sysRoleMenus.forEach(sysRoleMenu => {
        this.endpointMenuItems.forEach((endpointMenu, index) => {
          returnNode = {}
          if(endpointMenu.children && endpointMenu.children.length > 0) {
            getEndNode(endpointMenu,sysRoleMenu.sysMenuID)
            this.selection[0].push(returnNode)
          }
        });
      })

      // this.$set(this.selection, );
    },
    getSelectionName(id, sectionTitle) {
      return id + '_' + sectionTitle
    },
    handleReset() {
      console.log('handleReset')
    },
    onEditDialog(action) {
      console.log('action', action)
    },
    handleActive(e, index){
      console.log('e, index', e,index)
      let clickNode = e[0]
      let checkExist = false
      if(!clickNode){
        return
      }
      this.selection[index].push(clickNode)

      console.log('this.selection[index]', this.selection[index])
      this.activeArr[index] = []
    }
  },
  setup() {
    const active = ref([])
    const store = useStore()
    console.log('store', store)
    const roleMenus = reactive({
      roleID: -1,
      sysMenus: [],
    })

    const handleTreeview = ref((selectedItems, id, selection) => {
      console.log('selectedItems, id, selection', selectedItems, id,selection)
      roleMenus.value = {
        roleID: id,
        sysMenus: selectedItems,
      }
      console.log('roleMenus', roleMenus)
    })
    let selection = reactive({
      0:[],
      1:[],
      2:[],
      3:[],
      4:[],
      5:[],
      6:[],
      7:[],
      8:[],
      9:[]
    })
    let activeArr = reactive({
      0:[],
      1:[],
      2:[],
      3:[],
      4:[],
      5:[],
      6:[],
      7:[],
      8:[],
      9:[]
    })
    const endpointMenuItems = ref([])
    fetchListByEndpoint().then(response => {
      console.log('sysmenu', response)
      endpointMenuItems.value = response.data.record
      console.log('endpointMenuItems', endpointMenuItems.value)
    })

    const singleExpand = ref(true)
    const expanded = []
    const CRUDTable = ref(null)
    const loading = ref(false)
    const searchKeyWord = ref('')
    const organizations = ref([])
    let inputConfigs = [
      { md: 6, propName: 'id', label: 'ID', readonly: true },
      { md: 6, propName: 'name', label: 'Name' },
      { md: 6, propName: 'privilegeID', label: 'Privilege' },
      { md: 6, propName: 'remark', label: 'Remark' },
    ]
    let formConfig = {
      title: 'Role',
      headers: [
        { value: 'id', text: 'ID' },
        { value: 'name', text: 'Name' },
        { value: 'privilegeID', text: 'Privilege' },
        { value: 'actions', text: 'Actions', sortable: false },
      ],
    }
    return {
      activeArr,
      endpointMenuItems,
      handleTreeview,
      selection,
      singleExpand,
      expanded,
      CRUDTable,
      organizations,
      searchKeyWord,
      remoteCreateItem: createItem,
      remoteUpdateItem: updateItem,
      remoteDeleteItem: deleteItem,
      remoteGetItem: getItem,
      fetchList: fetchList,
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiExportVariant,
        mdiAccountOutline,
      },
      loading,
      inputConfigs: inputConfigs,
      formConfig: formConfig,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
